import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {Subscription, forkJoin} from "rxjs";
import { first, take } from 'rxjs/operators'
import {BsModalRef, BsModalService} from "ngx-bootstrap/modal";
import { HasFormComponent } from '../../../../../../shared/core/interfaces/hasFormComponent';
import { NotImplementedViewModel } from '../../../../../../shared/ui-ndms/view-models/not-implemented.view-model';
import { LookupService } from '../../../../../../shared/core/services/lookup.service';
import { ViewModelService } from '../../../../../../shared/core/services/view-model.service';
import { FormObjects } from '../../../../../../shared/core/utilities/formObjects';
import {CoreJpatsServices} from "../../../../shared/core-jpats/services/core-jpats.services";
import {UserManagementService} from "../../../../shared/core-jpats/services/user-management.service";
import { ModalAddFccComponent } from './modal-add-fcc/modal-add-fcc.component';

@Component({
  selector: 'modal-update-location',
  templateUrl: './modal-update-location.component.html',
  styleUrls: ['./modal-update-location.component.scss']
})
export class ModalUpdateLocationComponent extends HasFormComponent<NotImplementedViewModel> implements OnInit {
  resetForm(): void {
    throw new Error("Method not implemented.");
  }
  getCurrentSubscription: Subscription;

  currentOperation;
  currentFcc;
  currentLocation;

  operationLookups;
  fccLookups;
  locationLookups;

  constructor(
    private _formBuilder: FormBuilder,
    public bsModalRef: BsModalRef,
    private modalService: BsModalService,
    lookupService: LookupService,
    viewModelService: ViewModelService,
    private coreJpatsServices: CoreJpatsServices,
    private userManagementService: UserManagementService) {
    super(lookupService, viewModelService, NotImplementedViewModel, false);

    this.operationLookups = this.lookupService.get("Operations");
    for (var operation of this.operationLookups) {
      if (!operation.active) operation.description += " [ENDED]";
    }

    this.form = this._formBuilder.group({
      operation: [FormObjects.Lookup(), Validators.required],
      fcc: [FormObjects.Lookup(), Validators.required],
      location: [FormObjects.Lookup(), Validators.required]
    });

    this.getCurrentSubscription = this.userManagementService.getCurrentUser().subscribe((data) => {
      //populate internal status
      if (data.operation) this.currentOperation = data.operation;
      if (data.fcc) this.currentFcc = data.fcc;
      if (data.location) this.currentLocation = data.location;

      this.form.patchValue({
        operation: data.operation || undefined
      });

      this.loadFccLookups(data.operation);
    });
  }

  onOperationSet(operation) {
    if (operation) {
      if (operation != this.currentOperation) {
        this.currentOperation = operation;
        this.loadFccLookups(operation);
      }
    } else {
      this.lookupService.set("OperationFCCs", []);
      this.lookupService.set("OperationLocations", []);
      this.form.get("fcc").reset();
      this.form.get("location").reset();
    }
  }

  loadFccLookups(operation) {
    //save old FCC
    let oldFcc = this.currentFcc;

    //get FCCs associated with the operation
    let allFccs = this.lookupService.get("FCCs");
    this.coreJpatsServices.getFccsByOperation(operation.key).subscribe((fccList) => {
      this.fccLookups = allFccs.filter(i => i.active || fccList.some(x => x == i.key)).map(i => Object.assign({}, i)); //remove inactive FCCs, except those associated with operation
      for (var fcc of this.fccLookups) {
        if (!fcc.active) fcc.description += " [INACTIVE]";
      }
      this.lookupService.set("OperationFCCs", this.fccLookups as any[]);

      //restore old FCC as selection, if still valid
      if (oldFcc && !this.fccLookups.some(fcc => fcc.key === oldFcc.key)) {
        this.form.get("fcc").reset();
        this.form.get("location").reset();
      } else {
        this.form.patchValue({
          fcc: oldFcc || undefined
        });
        this.onFccSet(oldFcc);  //need to call this to refresh locations list, which can vary by operation
      }
    });
  }

  onFccSet(event) {
    if (event) {
      this.currentFcc = event;
      this.loadLocationLookups(event);
    } else {
      this.lookupService.set("OperationLocations", []);
      this.form.get("location").reset();
    }
  }

  loadLocationLookups(fcc) {
    //save old location
    let oldLoc = this.currentLocation;

    //get all locations for the selected FCC, and also the locations used in the selected Operation
    const locByFcc = this.coreJpatsServices.getLocationsByFcc(fcc.key);
    const locByOp = this.coreJpatsServices.getLocationsByOperation(this.currentOperation.key);
    forkJoin([locByFcc, locByOp]).pipe(take(1)).subscribe(
      ([fccLocations, operationLocations]) => {
        //filter to locations that are active OR were used in the selected Operation
        this.locationLookups = fccLocations.filter(i => i.active || operationLocations.some(x => x == i.key));
        for (var loc of this.locationLookups) {
          if (!loc.active) loc.description += " [INACTIVE]";
        }
        this.lookupService.set("OperationLocations", this.locationLookups as any[]);

        //Restore old Location selection, if still valid
        if (oldLoc && !this.locationLookups.some(loc => loc.key === oldLoc.key)) {
          this.form.get("location").reset();
        } else {
          this.form.patchValue({
            location: oldLoc || undefined
          });
        }
      }
    );
  }

  onLocationSet(location) {
    if (location) this.currentLocation = location;
  }

  ngOnInit() {
  }

  onComplete() {
    this.getCurrentSubscription.unsubscribe();
    this.userManagementService.updateLocation({
      fccKey: this.form.value.fcc.key,
      locationKey: this.form.value.location.key,
      operationKey: this.form.value.operation.key
    })
      .subscribe((res) => {

        this.bsModalRef.hide();
      });
  }

  addFcc() {
    this.bsModalRef.hide();
    let modalAddFccComponent = this.modalService.show(ModalAddFccComponent, { ignoreBackdropClick: true });

    modalAddFccComponent.onHidden.pipe(first()).subscribe(() => {
      //If all modals are closed, return focus to location button
      if (document.body.className.indexOf('modal-open') == -1) {
        document.getElementById("jpatsChangeLocationBtn")?.focus();
      }
    });

  }
}
